import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import Couriers from './Couriers';
import styles from './styles';

function mapStateToProps(state) {
  const { isLoading, couriers } = state.courier;
  return {
    isLoading,
    couriers,
  };
}

const Styled = withStyles(styles)(Couriers);

export default connect(
  mapStateToProps,
)(Styled);
